import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { useDelayedTrue } from 'hooks/useDelayedTrue';
import './instoreqrRestaurantBody.scss';
import styles from './InstoreqrLoadingPage.module.scss';

const BODY_CLASS = 'instoreqr-restaurant-theme';
const SHOW_SPINNER_DELAY_MS = 150;

/**
 * Full-page loading state for InStoreQR routes — restaurant cream/red theme,
 * independent of AbraFi light/dark.
 */
function InstoreqrLoadingPage() {
  const { t } = useTranslation();
  const showSpinner = useDelayedTrue(true, SHOW_SPINNER_DELAY_MS);

  useEffect(() => {
    document.body.classList.add(BODY_CLASS);
    return () => {
      document.body.classList.remove(BODY_CLASS);
    };
  }, []);

  return (
    <div
      className={styles.page}
      data-theme="light"
      data-instoreqr-theme="restaurant"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={t('pages.instoreqr.loadingPage.aria')}
    >
      {showSpinner ? (
        <div className={styles.content}>
          <p className={styles.brand}>
            {t('pages.instoreqr.loadingPage.brand')}
          </p>
          <Loader2 className={styles.spinner} size={32} aria-hidden />
          <p className={styles.label}>
            {t('pages.instoreqr.loadingPage.label')}
          </p>
        </div>
      ) : null}
    </div>
  );
}

export default InstoreqrLoadingPage;
